import { Controller } from '@hotwired/stimulus'

const EDITOR_MOUNT_SELECTOR = '[data-controller~="turbo-mount-text-editor"]'
const EDITOR_PROPS_ATTRIBUTE = 'data-turbo-mount-text-editor-props-value'

export default class extends Controller {
  static targets = ['editor', 'input']

  connect () {
    this.editorSnapshots = this.editorTargets.map((wrapper) => (
      wrapper.querySelector(EDITOR_MOUNT_SELECTOR)?.getAttribute(EDITOR_PROPS_ATTRIBUTE)
    ))

    this.inputSnapshots = this.inputTargets.map((wrapper) => {
      const field = this.fieldFor(wrapper)
      return field && this.snapshotValue(field)
    })
  }

  revert () {
    this.editorTargets.forEach((wrapper, index) => {
      const snapshot = this.editorSnapshots[index]
      const mount = wrapper.querySelector(EDITOR_MOUNT_SELECTOR)
      if (mount && snapshot) this.remountEditor(mount, snapshot)
    })

    this.inputTargets.forEach((wrapper, index) => {
      const field = this.fieldFor(wrapper)
      const snapshot = this.inputSnapshots[index]
      if (field && snapshot !== undefined) this.restoreValue(field, snapshot)
    })
  }

  // The props-value attribute is only ever set once from the server; typing
  // in the editor never changes it, so re-setting it to the same snapshot
  // string doesn't trigger Stimulus's props-changed callback (it diffs the
  // value first). Drive the turbo-mount controller's own lifecycle instead,
  // which unconditionally unmounts and remounts the React root.
  remountEditor (mount, snapshot) {
    mount.setAttribute(EDITOR_PROPS_ATTRIBUTE, snapshot)

    const identifier = mount.getAttribute('data-controller')
    const editorController = this.application.getControllerForElementAndIdentifier(mount, identifier)
    if (!editorController) return

    editorController.disconnect()
    editorController.connect()
  }

  fieldFor (wrapper) {
    // Skip Rails' hidden "0" fallback input that precedes every check_box.
    return wrapper.querySelector('input:not([type="hidden"]), select, textarea')
  }

  snapshotValue (field) {
    return field.type === 'checkbox' || field.type === 'radio' ? field.checked : field.value
  }

  restoreValue (field, snapshot) {
    if (field.type === 'checkbox' || field.type === 'radio') {
      field.checked = snapshot
      field.dispatchEvent(new Event('change', { bubbles: true }))
    } else {
      field.value = snapshot
      field.dispatchEvent(new Event('input', { bubbles: true }))
    }
  }
}
